import { jsx as _jsx } from "react/jsx-runtime";
import { useGeneratePath, useIsActive, useRouteNavigate, } from "@madmedical/user";
import { RoutingProvider as UiRoutingProvider } from "@madmedical/ui";
const RoutingProvider = ({ children }) => {
    const navigate = useRouteNavigate();
    const generatePath = useGeneratePath();
    const isActive = useIsActive();
    return (_jsx(UiRoutingProvider, Object.assign({ value: { navigate, isActive, generatePath } }, { children: children })));
};
export default RoutingProvider;
